export type SupportTopicOption = {
  value: string;
  label: string;
};

export const hasDescriptionTopic = "Questions about future projects or services";
export const optionTopic: SupportTopicOption[] = [
  {
    value: "Questions About Existing Project",
    label: "Questions About Existing Project",
  },
  {
    value: "Questions about future projects or services",
    label: "Questions about future projects or services",
  },
  {
    value: "Feedback",
    label: "Feedback",
  },
  {
    value: "Other",
    label: "Other",
  },
];